"use client";

import { IconPalette } from "@tabler/icons-react";
import Logo from "src/components/app/Logo/Logo";
import PlatformStatusChip from "src/components/app/PlatformStatusChip/PlatformStatusChip";
import PortalWorkspaceSwitcher from "src/components/app/PortalWorkspaceSwitcher/PortalWorkspaceSwitcher";
import Button from "src/components/common/Button/Button";
import Link from "src/components/common/Link/Link";
import SidebarNavigation from "src/components/common/SidebarNavigation/SidebarNavigation";
import { useAuth } from "src/lib/contexts/AuthContext";
import { useExtracted } from "#i18n";
import DocsSidebar from "./DocsSidebar";

const DocsNavigationSidebar = () => {
  const translateMessage = useExtracted();
  const { authState } = useAuth();
  const isAuthenticated = Boolean(authState?.user);

  return (
    <aside
      aria-label={translateMessage("Documentation sidebar")}
      data-theme="dark"
      className="flex h-full flex-col overflow-hidden bg-background text-foreground"
    >
      <div
        className={`flex shrink-0 items-center justify-between gap-2 px-5 pb-4 pt-5 ${isAuthenticated ? "" : "border-b border-border"}`}
      >
        <Link className="group inline-flex transition-opacity hover:opacity-80" href="/">
          <Logo size="md" className="text-foreground" />
        </Link>
        {/* Loaded after hydration: docs documents are cached for every visitor. */}
        <PlatformStatusChip />
      </div>

      <PortalWorkspaceSwitcher showPortalLink />

      <div className="min-h-0 flex-1 overflow-hidden">
        <DocsSidebar className="h-full" />
      </div>

      {isAuthenticated && process.env.NODE_ENV === "development" ? (
        <div className="shrink-0 border-t border-border p-4">
          <SidebarNavigation.Label>{translateMessage("Design Resources")}</SidebarNavigation.Label>
          <SidebarNavigation.Item
            href="/portal/design-system"
            icon={<IconPalette size={16} stroke={1.8} aria-hidden />}
          >
            {translateMessage("Component Showcase")}
          </SidebarNavigation.Item>
        </div>
      ) : null}

      {!isAuthenticated ? (
        <div className="grid shrink-0 gap-2 border-t border-border p-3">
          <Button
            href="/portal?auth=login"
            label={translateMessage("Sign in")}
            size="sm"
            variant="outline"
            className="w-full"
          >
            {translateMessage("Sign in")}
          </Button>
          <Button
            href="/portal?auth=login"
            label={translateMessage("Get started")}
            size="sm"
            className="w-full"
          >
            {translateMessage("Get started")}
          </Button>
        </div>
      ) : null}
    </aside>
  );
};

export default DocsNavigationSidebar;
